import React from "react";
import TrackVisibility from "react-on-screen";
import Counter from "../elements/Counter";
import Pagetitle from "../elements/Pagetitle";
import Skill from "../elements/Skill";

const aboutContent = {
  name: "Bolby",
  avatarImage: "/images/marcos-avatar.jpg",
  content1:
    "Accomplished Senior Software Engineer with extensive experience in full-stack development, specializing in C#, .NET Core, JavaScript, React, SQL Databases Adept in building robust web applications, microservices, and implementing DevOps practices. Proven track record in agile project management, leading teams, and driving software excellence in fast-paced environments.",
  content2:
    "Developed products for commercial clients in the oil and gas, hospitality, health, real estate, pension and digital content segments, publishing mobile applications along with front-end and back-end web development, overseeing database management, and handling DevOps tasks.",
  content3: "Certified at Microsoft, Scrum Alliance and Kanban University.",
};

const progressData = [
  {
    title: "C#",
    percantage: 95,
    progressColor: "#2F6F73",
  },
  {
    title: "React",
    percantage: 80,
    progressColor: "#3A7D8C",
  },
  {
    title: "PHP",
    percantage: 80,
    progressColor: "#6D5D94",
  },
  {
    title: "Wordpress",
    percantage: 80,
    progressColor: "#C0563D",
  },
  {
    title: "SQL",
    percantage: 90,
    progressColor: "#E0A838",
  },
  {
    title: "Javascript",
    percantage: 95,
    progressColor: "#D18A2C",
  },
  {
    title: "Angular",
    percantage: 70,
    progressColor: "#B84A3A",
  },
  {
    title: "HTML5",
    percantage: 100,
    progressColor: "#C0563D",
  },
  {
    title: ".Net",
    percantage: 90,
    progressColor: "#496A81",
  },
  {
    title: "Typescript",
    percantage: 85,
    progressColor: "#2F6F73",
  },
];

const counterData = [
  {
    title: "I'm Sofia's father",
    count: 9999,
    icon: "icon-badge",
  },
  {
    title: "Projects completed",
    count: 126,
    icon: "icon-fire",
  },
  {
    title: "Cup of coffee",
    count: 5670,
    icon: "icon-cup",
  },
  {
    title: "Satisfied clients",
    count: 351,
    icon: "icon-people",
  },
];

function About() {
  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="row">
          <div className="col-md-2">
            <div className="text-center text-md-left about-logo">
              <img src={aboutContent.avatarImage} alt={aboutContent.name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-10 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{aboutContent.content1}</p>
                  <p>{aboutContent.content2}</p>
                  <p>{aboutContent.content3}</p>
                  <div className="mt-3">
                    <a
                      href="https://1drv.ms/b/s!AhG6K52WP6wkiON-HtENnMJNHqPCww?e=WgroBh"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-default"
                    >
                      Download CV
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-3">
                  {progressData
                    .slice(0, parseInt(progressData.length / 2))
                    .map((progress, key) => (
                      <TrackVisibility
                        once
                        key={key}
                        className="progress-wrapper"
                      >
                        <Skill progress={progress} />
                      </TrackVisibility>
                    ))}
                </div>
                <div className="col-md-3 about-progress-data">
                  {progressData
                    .slice(
                      parseInt(progressData.length / 2),
                      progressData.length
                    )
                    .map((progress, key) => (
                      <TrackVisibility
                        once
                        key={key}
                        className="progress-wrapper"
                      >
                        <Skill progress={progress} />
                      </TrackVisibility>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
        <div className="row fix-spacing">
          {counterData.map((counter, key) => (
            <div key={key} className="col-md-3 col-sm-6">
              <TrackVisibility once>
                <Counter counterItem={counter} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
